import { render } from "./match-details-modal-table.vue?vue&type=template&id=3f1e5f36&scoped=true&ts=true"
import script from "./match-details-modal-table.vue?vue&type=script&lang=ts"
export * from "./match-details-modal-table.vue?vue&type=script&lang=ts"

import "./match-details-modal-table.vue?vue&type=style&index=0&id=3f1e5f36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1e5f36"]])

export default __exports__